import { render, staticRenderFns } from "./upgrade-policies.vue?vue&type=template&id=bb4f1ece"
import script from "./upgrade-policies.vue?vue&type=script&lang=ts"
export * from "./upgrade-policies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports